import { render, staticRenderFns } from "./SVGScale.vue?vue&type=template&id=5f893fa3&scoped=true&"
import script from "./SVGScale.vue?vue&type=script&lang=js&"
export * from "./SVGScale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f893fa3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f893fa3')) {
      api.createRecord('5f893fa3', component.options)
    } else {
      api.reload('5f893fa3', component.options)
    }
    module.hot.accept("./SVGScale.vue?vue&type=template&id=5f893fa3&scoped=true&", function () {
      api.rerender('5f893fa3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGScale.vue"
export default component.exports